<template>
  <div>
    <v-card class="pa-5" rounded="xl">
      <div class="pt-2">
        <h3 class="txtLog">Reset Password</h3>
        <div v-if="this.err">
          <v-card
            v-if="this.loginSuccess"
            class="mt-2 mb-5 d-flex justify-start align-center px-1 py-1"
            rounded="md"
            style="background-color: #0abe32"
          >
            <v-icon color="white">mdi-check-circle</v-icon>
            <h3 class="txtError ml-2">Success</h3>
          </v-card>
          <v-card
            v-if="!this.loginSuccess"
            class="mt-2 mb-5 d-flex justify-start align-center px-1 py-1"
            rounded="md"
            style="background-color: #be0a15"
          >
            <v-icon color="white">mdi-close-circle</v-icon>
            <h3 class="txtError ml-2">Error</h3>
          </v-card>
        </div>

        <form @submit.prevent="login">
          <v-text-field
            prepend-inner-icon="mdi-lock"
            outlined
            dense
            v-model="password"
            :error-messages="PasswordError"
            label="Password"
            :append-icon="show ? 'mdi-eye' : 'mdi-eye-off'"
            :type="show ? 'text' : 'password'"
            color="#377F65"
            @click:append="show = !show"
            @input="$v.password.$touch()"
            @blur="$v.password.$touch()"
          ></v-text-field>

          <v-text-field
            prepend-inner-icon="mdi-lock"
            outlined
            dense
            v-model="repwd"
            :error-messages="repwderr"
            label="Confirm password"
            :append-icon="show2 ? 'mdi-eye' : 'mdi-eye-off'"
            :type="show2 ? 'text' : 'password'"
            color="#377F65"
            @click:append="show2 = !show2"
            @input="$v.repwd.$touch()"
            @blur="$v.repwd.$touch()"
          ></v-text-field>
          <div class="parentBtn">
            <v-btn
              block
              class="btn"
              type="login"
              v-if="!loading"
              color="#006341"
              depressed
              dark
            >
              Change Password
            </v-btn>
            <v-btn
              block
              class="btn"
              depressed
              v-if="loading"
              color="#006341"
              dark
            >
              Loading..
            </v-btn>
          </div>
        </form>
      </div>
    </v-card>
  </div>
</template>

<script>
import { validationMixin } from "vuelidate";
import { required, minLength, sameAs } from "vuelidate/lib/validators";
export default {
  name: "login",
  mixins: [validationMixin],
  validations: {
    password: { required, minLength: minLength(8) },
    repwd: { required, sameAsPassword: sameAs("password") },
  },
  computed: {
    PasswordError() {
      const errors = [];
      if (!this.$v.password.$dirty) return errors;
      !this.$v.password.minLength &&
        errors.push("Password minimum 8 characters!");
      !this.$v.password.required && errors.push("Password is required!");
      return errors;
    },
    repwderr() {
      const errors = [];
      if (!this.$v.repwd.$dirty) return errors;
      !this.$v.repwd.sameAsPassword &&
        errors.push("Password confirmation doesn't match!");
      !this.$v.repwd.required && errors.push("Password is required!");
      return errors;
    },
  },
  data() {
    return {
      password: "",
      repwd: "",
      show: false,
      show2: false,
      errAlert: false,
      loading: false,
      err: null,
      loginSuccess: true,
    };
  },
  methods: {
    login() {
      this.$v.$touch();
      if (this.$v.$invalid) {
        return;
      } else {
        this.loading = true;
        let body = {
          password: this.password,
          password_confirmation: this.repwd,
          token: this.$route.params.token,
          email: this.$route.params.email,
        };
        let data = {
          path: `auth/password/reset`,
          body: body,
        };
        this.$store
          .dispatch("user/postApi", data)
          .then((data) => {
            if (data.status == "success") {
              this.$router.push("/auth/login");
            }

            this.loading = false;
          })
          .catch((err) => {
            this.$store.dispatch("notify", {
              msg: err.message,
              type: "error",
            });
            this.err = err.message;
            this.loginSuccess = false;
            this.loading = false;
          });
      }
    },
  },
};
</script>

<style>
.txtError {
  font-size: 70%;
  color: white;
  font-weight: bold;
}
.txtLog {
  text-align: left;
  margin-bottom: 10px;
}

.txtLog2 {
  text-align: left;
  font-weight: normal;
}
@media (max-width: 900px) {
  .txtLog {
    text-align: left;
    margin-bottom: 5px;
  }
}
@media (max-width: 900px) {
  .txtLog2 {
    text-align: left;
    margin-bottom: 10px;
    font-weight: normal;
  }
}
.parentBtn {
  display: flex;
  justify-content: center;
  margin-top: 25px;
}
@media (max-width: 900px) {
  .parentBtn {
    display: flex;
    justify-content: center;
    margin-top: 0px;
  }
}
.btn {
  margin-bottom: 25px;
  padding-top: 40px;
  padding-bottom: 40px;
  text-transform: capitalize;
}
</style>
